import React, { useState, FC } from "react";
import { useTranslation } from "react-i18next";

interface OrderBtnProps {
  // eslint-disable-next-line no-unused-vars
  handleSelectOrder: (index: number) => void;
}

const OrderBtn: FC<OrderBtnProps> = ({ handleSelectOrder }) => {
  const { t } = useTranslation("my_account");
  const [isOptionsOpen, setIsOptionsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(0);
  const optionsList = ["Recentes primeiro", "Antigas primeiro"];

  const toggleOptions = () => setIsOptionsOpen(!isOptionsOpen);

  return (
    <div className="categories__order">
      <button
        className="categories__btn categories__order-btn"
        type="button"
        aria-haspopup="listbox"
        aria-expanded={isOptionsOpen}
        onClick={toggleOptions}
      >
        Ordenar
        <span
          className="material-icons material-icons-round"
          role="img"
          aria-label={t("order.order")}
          title={t("order.order")}
        >
          &#xE5C7;
        </span>
      </button>

      <ul
        className={` dropdown-menu categories__order-list ${isOptionsOpen && "categories__order-list--open"}`}
        role="listbox"
        aria-activedescendant={optionsList[selectedOption]}
        tabIndex={-1}
      >
        {optionsList.map((option, index) => (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events
          <li
            id={option}
            className="categories__order-item"
            role="option"
            aria-selected={selectedOption === index}
            tabIndex={0}
            key={option}
            onClick={() => {
              setSelectedOption(index);
              setIsOptionsOpen(false);
              handleSelectOrder(index);
            }}
          >
            {option}
            {selectedOption === index && (
              <span
                className="material-icons material-icons-round"
                role="img"
                aria-label={t("order.selected")}
                title={t("order.selected")}
              >
                &#xE5CA;
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default OrderBtn;
